import React from 'react';

import { FaqAdminDto } from 'lib_api/lib/api/gen';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import { MarkdownFieldDisplay } from 'components/FieldDisplay/MarkdownFieldDisplay';
import BaseModal from 'components/WrappedComponents/BaseModal';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { LABEL_ID_CORRELATION } from 'utils/global';

import { mapUserProfiles } from '../../utils';

interface ModalDetailsProps {
  faq: FaqAdminDto;
  visible: boolean;
  close: () => void;
}

function ModalDetails({
  faq,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  return (
    <BaseModal
      isVisible={visible}
      closeModal={close}
      width={BaseModalWidthUtils.xLargeWidth}
    >
      <>
        <FieldDisplay
          labelClass="labelDetail"
          label={LABEL_ID_CORRELATION}
          value={faq.idCorrelation}
        />
        <FieldDisplay
          labelClass="labelDetail"
          label="Domaine"
          value={faq.domainName}
        />
        <FieldDisplay
          additionalValueClassName="multiLineValue"
          labelClass="labelDetail"
          label="Titre"
          value={faq.title}
        />
        <FieldDisplay
          additionalValueClassName="multiLineValue"
          labelClass="labelDetail"
          label="Rôles concernés"
          value={mapUserProfiles(faq.profiles)}
        />
        <MarkdownFieldDisplay
          additionalValueClassName="textValue"
          labelClass="labelDetail"
          label="Contenu"
          value={faq.content}
        />
      </>
    </BaseModal>
  );
}

export default ModalDetails;
